module.exports = __webpack_public_path__ + "static/img/challenge-1.6ec16ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/characters/challenge-1.svg
// module id = UnEF
// module chunks = 1